/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-plusplus */
/* eslint-disable react/prop-types */
import React from "react";
import {
  TableContainer,
  TableCell,
  TableRow,
  TableHead,
  Table as MuiTable,
  Box,
  TableBody,
} from "@mui/material";
import PropTypes from "prop-types";
import Typography from "../../../../components/common/new/Typography/Typography";
import style from "./tableStyle";

const BLOCK = "BLOCK";

const getMonthsFromData = (data) => {
  if (!data || data.length === 0) {
    return [];
  }

  const dates = data.map((item) => new Date(item.generatedAt));
  const minDate = new Date(Math.min(...dates.map((date) => date.getTime())));
  const maxDate = new Date(Math.max(...dates.map((date) => date.getTime())));

  const numberOfMonths =
    (maxDate.getFullYear() - minDate.getFullYear()) * 12 +
    (maxDate.getMonth() - minDate.getMonth()) +
    1;

  const months = [];
  for (let i = 0; i < numberOfMonths; i++) {
    const month = new Date(minDate.getFullYear(), minDate.getMonth() + i);
    months.push(
      month.toLocaleString("en-US", { month: "short", year: "2-digit" })
    );
  }
  return months;
};

const getUniqueMonths = (monthsArray) => [...new Set(monthsArray)];

function Table({
  checkAllToggle,
  columns,
  rows,
  scrollable,
  columnCellStyle,
  headCellStyle,
  hasAction = false,
  searchData,
}) {
  //   const hierarchyValues = searchData.map((data) => data.hierarchy);
  //   const isBlock = hierarchyValues[0] === BLOCK;
  const months = getUniqueMonths(getMonthsFromData(searchData));

  // Determine how many non-month (org-structure) columns we have so that the
  // "Subscriptions MIS" grouped header spans exactly those columns.
  // OLD: colSpan was hardcoded to 6, which breaks alignment when Cluster is present.
  // const safeOsColSpan = 6;
  const osColSpan = Array.isArray(columns)
    ? Math.max(columns.length - months.length * 3, 0)
    : 0;
  const safeOsColSpan = osColSpan || 6;
  return (
    <TableContainer
      style={{
        ...style.container,
        ...{ overflow: scrollable ? "auto" : "hidden" },
      }}
    >
      <MuiTable aria-label="collapsible table" stickyHeader>
        <TableHead sx={{ paddingTop: "1.4rem" }}>
          <TableRow
            sx={{
              padding: "1rem",
              // Ensure the grouped header row paints across the full header width.
              backgroundColor: style.tableHeadCell?.background,
            }}
          >
            {/* <TableCell
              style={{
                ...style.tableHeadCell,
                ...columnCellStyle,
                paddingLeft: "0px",
                marginRight: "0px",
              }}
            />
            <TableCell
              style={{
                ...style.tableHeadCell,
                ...columnCellStyle,
                paddingLeft: "0px",
                marginRight: "0px",
              }}
            /> */}
            <TableCell
              // OLD:
              // align="right"
              align="center"
              // OLD:
              // colSpan={6}
              colSpan={safeOsColSpan}
              sx={{
                ...style.tableHeadCell,
                ...columnCellStyle,
                // OLD:
                // paddingLeft: "0px",
              }}
            >
              <Typography
                variant="small"
                weight={600}
                sx={{ color: "#000000" }}
              >
                {/* OLD:
                 <Box
                   sx={{
                     marginLeft: "-11px",
                     borderLeft: "1px solid rgba(94, 94, 94, 1)",
                   }}
                 >
                   Subscriptions MIS
                 </Box>
                */}

                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    // Match the second header row divider alignment (border on inner box).
                    borderRight: "1px solid rgba(94, 94, 94, 1)",
                    paddingRight: "0.6rem",
                  }}
                >
                  Subscriptions MIS
                </Box>
              </Typography>
            </TableCell>
            {months.map((month, index) => (
              <TableCell
                key={index}
                // OLD:
                // align="right"
                align="center"
                colSpan={3}
                sx={{
                  ...style.tableHeadCell,
                  ...columnCellStyle,
                  // OLD:
                  // paddingLeft: "0px",
                  // OLD:
                  // paddingRight: "10px",
                  paddingRight: index === months.length - 1 ? "0px" : undefined,
                }}
              >
                <Typography
                  variant="small"
                  weight={600}
                  sx={{ color: "#000000" }}
                >
                  {/* OLD:
                   <Box
                     sx={{
                       marginLeft: "-11px",
                       borderLeft: "1px solid rgba(94, 94, 94, 1)",
                     }}
                   >
                     {month}
                   </Box>
                  */}

                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      borderRight:
                        index !== months.length - 1
                          ? "1px solid rgba(94, 94, 94, 1)"
                          : "",
                      paddingRight: "0.6rem",
                    }}
                  >
                    {month}
                  </Box>
                </Typography>
              </TableCell>
            ))}
          </TableRow>
          <TableRow sx={{ padding: "1rem" }}>
            {columns?.map((col, index) => {
              const Component = col.key === "checkBox" ? col.displayName : null;
              return (
                <TableCell
                  key={col.displayName}
                  align="left"
                  rowSpan={col.rowspan ? col.rowSpan : 1}
                  colSpan={col.colSpan ? col.colSpan : 1}
                  style={{ ...style.tableHeadCell, ...columnCellStyle }}
                >
                  <Box
                    sx={{
                      borderRight:
                        index !== columns.length - 1
                          ? "1px solid rgba(94, 94, 94, 1)"
                          : "",
                      paddingRight: "0.6rem",
                    }}
                  >
                    <Typography
                      variant="small"
                      weight={600}
                      style={headCellStyle}
                      sx={{ color: "#000000" }}
                    >
                      {Component ? (
                        <Component
                          sx={{ padding: "3px 14.8px" }}
                          onChange={(e) => checkAllToggle(e.target.checked)}
                        />
                      ) : (
                        col.displayName
                      )}
                    </Typography>
                  </Box>
                </TableCell>
              );
            })}
            {hasAction ? <TableCell sx={style.tableHeadCell} /> : null}
          </TableRow>
        </TableHead>
        <TableBody
          sx={{
            ...style.tableBody,
            "& .MuiTypography-root": {
              fontSize: "14px",
              color: "#000000",
            },
            "tr:nth-child(even)": {
              backgroundColor: "#E8EDF4",
            },
          }}
        >
          {rows}
        </TableBody>
      </MuiTable>
    </TableContainer>
  );
}

const propTypes = {
  checkAllToggle: PropTypes.fun,
  columns: PropTypes.arrayOf(PropTypes.objectOf()).isRequired,
  rows: PropTypes.arrayOf(PropTypes.element).isRequired,
  hasAction: PropTypes.bool,
  columnCellStyle: PropTypes.arrayOf(PropTypes.objectOf()),
  scrollable: PropTypes.bool,
  headCellStyle: PropTypes.objectOf(),
  searchData: PropTypes.arrayOf(PropTypes.objectOf()).isRequired,
};

const defaultProps = {
  hasAction: false,
  scrollable: false,
  columnCellStyle: {},
  headCellStyle: {},
  checkAllToggle: () => {},
};

Table.propTypes = propTypes;
Table.defaultProps = defaultProps;

export default Table;
